import { OverlayTrigger, Popover } from "react-bootstrap";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const FieldTooltip = ({ content = "" }) => {
    return (
        <OverlayTrigger
            trigger={["click"]}
            overlay={
                <Popover id="your-popover-id">
                    <Popover.Content className="field-tooltip">
                        <Markdown plugins={[remarkGfm]} linkTarget="_blank">
                            {content}
                        </Markdown>
                    </Popover.Content>
                </Popover>
            }
            rootClose={true}
            placement="auto"
        >
            <button className="field-tooltip-button" aria-label="Show Tooltips" type="button"></button>
        </OverlayTrigger>
    );
};
